import { FC } from "react";
import { useDispatch } from "react-redux";

import { UserDrivingPermitForm } from "Bands/components";
import { createUserDrivingPermit, dispatchGetUserDrivingPermits } from "Bands/state";
import { IUserDrivingPermitPatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { IdCard } from "shared/assets/icons";

const { userDrivingPermit: permitCopy } = copy;

interface Props {
  handleClose: () => void;
}

export const CreateUserDrivingPermitModal: FC<Props> = ({ handleClose }) => {
  const dispatch = useDispatch();

  const buttons: IFormButtons = {
    primary: {
      children: permitCopy.buttons.create,
    },
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserDrivingPermitPatchData) => {
    dispatch(createUserDrivingPermit(data));
  };

  const handleSuccess = () => {
    dispatchGetUserDrivingPermits(dispatch);
  };

  return (
    <UserEntityModal
      title={permitCopy.create.title}
      icon={IdCard}
      action={USER_ACTIONS.createUserDrivingPermit}
      buttons={buttons}
      successMessage={permitCopy.messages.created}
      Component={UserDrivingPermitForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      handleSuccess={handleSuccess}
    />
  );
};
